import React from 'react';
import { Typography, Box } from '@mui/material';

const Carteirinha: React.FC = () => {
  return (
    <div className="carteirinha-page">
      <Typography variant="h4" component="h1" gutterBottom>
        Carteirinha BN
      </Typography>
      <Box>
        <Typography variant="body1">
          Página da carteirinha em desenvolvimento...
        </Typography>
      </Box>
    </div>
  );
};

export default Carteirinha; 